import React from 'react';
import { Flex, Heading, Center } from '@chakra-ui/react';

function TargetCard({ icon, iconBg, title }) {
  return (
    <Flex
      w={{base:"100%", md:"300px"}}
      border={"1px solid #DDDDDD"}
      borderRadius={"20px"}
      padding={"20px"}
      alignItems={"center"}
      justifyContent={"center"}
      flexDirection={"column"}
      gap={"20px"}
    >
      <Center
        w="44px"
        h="44px"
        borderRadius="full"
        bg={iconBg}
        flexShrink={0}
      >
        <span
          className="material-symbols-outlined"
          style={{ fontSize: '24px', color: 'black' }}
        >
          {icon}
        </span>
      </Center>
      <Heading
        as="h3"
        textAlign={"center"}
        fontSize={{ base: "20px", md: "20px" }}
        fontWeight="600"
        fontFamily="Inter, sans-serif"
        color="black"
        letterSpacing="0.1px"
        w={"266px"}
        lineHeight="1.2"
      >
        {title}
      </Heading>
    </Flex>
  );
}

export default function TargetSection() {
  return (
    <Flex
      as="section"
      aria-label="À qui s'adresse Résonance"
      flexDirection="column"
      alignItems={{ base: "center", md: "center" }}
      paddingY="40px"
      gap={{ base: "20px", md: "40px" }}
      w={"100%"}
    >
        <Heading
          as="h2"
          fontSize={{ base: "30px", md: "45px" }}
          fontWeight="bold"
          fontFamily="Inter, sans-serif"
          color="black"
          textAlign={{ base: "start", md: "center" }}
          letterSpacing="0.1px"
          lineHeight="1.2"
        >
          Tu veux…
        </Heading>
        <Flex flexDirection={"column"} gap={"20px"} alignItems={"center"}>
          <Flex 
          flexDirection={{base:"column", md:"row"}} 
          alignItems={"center"}
          gap={"20px"}>
            <TargetCard
              icon="voice_selection"
              iconBg="#C7E5F4"
              title="Prendre la parole plus facilement"
            />
            <TargetCard
              icon="lightbulb"
              iconBg="#BEEAD7"
              title="Exprimer tes idées avec clarté"
            />
          </Flex>
          <Flex flexDirection={{base:"column", md:"row"}} gap={"20px"}>
            <TargetCard
              icon="hearing"
              iconBg="#B5EEB8"
              title="Écouter des points de vue différents"
            />
            <TargetCard
              icon="moving"
              iconBg="#C7E5F4"
              title="Progresser sans stress ni jugement"
            />
          </Flex>
        </Flex>
      
    </Flex>
  );
}
